import { Dropzone } from '@billy/design-system'
import { ReactElement, ReactNode, useState } from 'react'
import { FileRejection } from 'react-dropzone'

import { MAX_FILE_SIZE_IN_BYTES } from '../../constants/uploadConstants'
import * as Styled from './styles'

interface DocumentsDropzoneProps {
  children: ReactNode
  heightOffset?: number
  isDisabled: boolean
  onFilesSelect: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void
}

export const DocumentsDropzone = ({
  children,
  heightOffset,
  isDisabled,
  onFilesSelect,
}: DocumentsDropzoneProps): ReactElement => {
  const [isDragActive, setIsDragActive] = useState(false)

  return (
    <Styled.DocumentsDropzoneWrapper
      data-testid="documents-dropzone"
      heightOffset={heightOffset}
      isDragActive={isDragActive && !isDisabled}
    >
      <Dropzone
        accept="all"
        customTrigger
        disabled={isDisabled}
        maxSize={MAX_FILE_SIZE_IN_BYTES}
        multiple
        onDragActive={setIsDragActive}
        onDrop={onFilesSelect}
        raw
      >
        {children}
      </Dropzone>
    </Styled.DocumentsDropzoneWrapper>
  )
}
